/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// material
import { Button, CopySnippetField } from '@insticator/insticator-ui'; // iui-material
// utils
import { getMigrationStatus, updateMigrationStatus, getUpdatedCodes } from 'state/actions/commentingState/advancedStatus'
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/advanced/advanced_styles';



/* ========== ~~~~~~~~~~ COMMENTING CODE ~~~~~~~~~~ ========== */
const Advanced = (props) => {
  const dispatch = useDispatch()
  const commentingUnitUUID = useSelector(state => state.commentingState.configStatus.commentingUnitUUID)
  const isLoading = useSelector(state => state.commentingState.advancedStatus.isFetching)
  const isError = useSelector(state => state.commentingState.advancedStatus.isError)
  const status = useSelector(state => state.commentingState.advancedStatus.migrationStatus)
  const commentingStatus = useSelector(state => state.commentingState.commentingStatus)
  const siteUUID = commentingStatus.selectedSite ? commentingStatus.selectedSite.value : null
  const codes = useSelector(state => state.commentingState.advancedStatus.codes)

  const startMigration = useCallback(() => {
    dispatch(updateMigrationStatus(commentingUnitUUID, 'STARTED'))
  }, [commentingUnitUUID])

  useEffect(() => {
    siteUUID && dispatch(getUpdatedCodes(siteUUID))
    commentingUnitUUID && dispatch(getMigrationStatus(commentingUnitUUID))
  }, [])

  const isMigrationPending = status !== 'COMPLETED' && status !== 'NOT_REQUIRED'

  if (isLoading && !status) return null
  // if (isError) return <span className='error'>Error fetching migration status</span>
  return (
    <div className={`advanced ${props.classes.advanced}`}>
      <div className='migration'>
        <span className='status'>Status: {status}</span>
        <Button
          disabled={status !== 'READY' || isLoading}
          type={'action'}
          variant={'primary'}
          text={'Start migration'}
          operation={'link'}
          behavior={'none'}
          action={startMigration}
        />
      </div>
      {isMigrationPending &&
        <div className='code'>
          <CopySnippetField
            title={'Header Code'}
            description={<div>Place the following code right after the <strong>{`<head>`}</strong> tag in your HTML source code.</div>}
            codeSnippet={codes.commentingUnitCode.headerCode}
          />

          <CopySnippetField
            title={'Commenting Unit Code'}
            description={
              <div>Place the Commenting Unit code inside of the <strong>{`<body>`}</strong> tag in your HTML source code where you want the Commenting Unit to appear in your site.
              </div>
            }
            codeSnippet={codes.commentingUnitCode.bodyCode}
          />

          <CopySnippetField
            title={'Community Add-On Code'}
            description={
              <div>
                Place the Community Add-On code inside of the <strong>&lt;body&gt;</strong> tag
                in your HTML source code where you want the Community Add-On to appear in your site.
              </div>
            }
            codeSnippet={codes.communityCode.code}
          />

          <CopySnippetField
            title={'Comments Counter Loading Script'}
            description={
              <div>
                Add the following script to the bottom of the page where you’d like to display the Comments Counter,
                right before the closing <strong>{'</body>'}</strong>:
              </div>
            }
            codeSnippet={codes.commentsCounterCode.bodyCode}
          />
        </div>
      }
    </div>
  );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Advanced);
